import { Component, HostBinding, Inject, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MediaObserver } from '@angular/flex-layout';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { NotificationDetail } from 'services/notification/notification.service';

@Component({
    selector: 'dialog-notification-component',
    styleUrls: ['notification.dialogcomponent.scss'],
    templateUrl: 'notification.dialogcomponent.html',
})
export class NotificationDialogComponent implements OnInit, OnDestroy {
    @HostBinding('class.smalldisplay') SmallDisplay: boolean;

    private _subrelease: Subject<void> = new Subject<void>();

    AllBoardHeaders = ['AsDesignee', 'RequestIssueNumber', 'Subject', 'RequestStatus', 'Actions'];
    AllNonBoardHeaders = ['AsDesignee', 'RequestIssueNumber', 'BoardMember', 'Subject', 'DateReferred', 'RequestStatus', 'Actions'];
    AsBoard: boolean;
    HasDesigneeEntries: boolean;
    TitleText: string;
    LastSizeCode: string;
    MessageText: string;
    Details: NotificationDetail[];
    DetailsData: MatTableDataSource<NotificationDetail>;
    VisibleHeaders: string[];
    VisibleColumns: string[];

    constructor(
        public dialogRef: MatDialogRef<NotificationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: BaseNotificationDialogOptions,
        private mediaChange: MediaObserver
    ) {
        this.TitleText = data.TitleText || 'Notification Details...';
        this.MessageText = data.MessageText || '';
        this.Details = data.Details || [];
        this.HasDesigneeEntries = this.Details.findIndex(r => r.AsDesignee === true) >= 0;
        this.AsBoard = data.AsBoard || false;
    }

    ngOnDestroy() {
        this._subrelease.next();
        this._subrelease.complete();
    }

    ngOnInit() {
        const self = this;

        self.LastSizeCode = self.mediaChange.isActive('xs')
            ? 'xs'
            : self.mediaChange.isActive('sm')
            ? 'sm'
            : self.mediaChange.isActive('md')
            ? 'md'
            : self.mediaChange.isActive('lg')
            ? 'lg'
            : 'xl';
        self.SmallDisplay = self.LastSizeCode === 'xs' || self.LastSizeCode === 'sm';
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AsBoard ? self.AllBoardHeaders : self.AllNonBoardHeaders;
        if (!self.HasDesigneeEntries) {
            self.VisibleHeaders = self.VisibleHeaders.filter(h => h !== 'AsDesignee');
        }
        self.VisibleColumns = self.VisibleHeaders.slice();

        self.mediaChange.media$.pipe(takeUntil(self._subrelease)).subscribe(media => {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.LastSizeCode = media.mqAlias;
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AsBoard ? self.AllBoardHeaders : self.AllNonBoardHeaders;
            if (!self.HasDesigneeEntries) {
                self.VisibleHeaders = self.VisibleHeaders.filter(h => h !== 'AsDesignee');
            }
            self.VisibleColumns = self.VisibleHeaders.slice();
        });

        this.DetailsData = new MatTableDataSource<NotificationDetail>(self.Details);
    }

    // #region OK Handler

    OKHandler() {
        this.dialogRef.close(<NotificationDetail>null);
    }

    // #endregion

    // #region View Referral Method

    ViewReferral(referral: NotificationDetail) {
        this.dialogRef.close(referral);
    }

    // #endregion
}

// #region Custom Classes

// #region Base Notification Dialog Options Class

export class BaseNotificationDialogOptions {
    TitleText?: string;
    MessageText?: string;
    OKText?: string;
    CancelText?: string;
    IconColor?: string;
    IconName?: string;
    ShowIcon?: boolean;
    height?: string;
    width?: string;
    Details?: NotificationDetail[];
    AsBoard?: boolean;
}

// #endregion

// #endregion
